import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { B as ButtCon, b as ButtConSvgIcon } from '../ButtCon/ButtCon.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';

var _excluded = ["state", "sx"],
  _excluded2 = ["icon"],
  _excluded3 = ["iconVariant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getButtConSx = function getButtConSx(_ref) {
  var state = _ref.state;
  switch (state) {
    case "success":
      return {
        bg: "base.color.status.success.bright"
      };
    case "fatal":
      return {
        bg: "base.color.status.fatal.bright"
      };
    case "initial":
    case "loading":
    default:
      return {};
  }
};
var getIconSx = function getIconSx(_ref2) {
  var state = _ref2.state,
    theme = _ref2.theme;
  switch (state) {
    case "success":
    case "fatal":
      return {
        fill: theme.base.colorMode === "onDark" ? "base.color.text.body.inverse.primary" : "base.color.text.body.primary"
      };
    case "initial":
    case "loading":
    default:
      return {};
  }
};
function StatefulButtCon(_ref3) {
  var _ref3$state = _ref3.state,
    state = _ref3$state === void 0 ? "initial" : _ref3$state,
    _ref3$sx = _ref3.sx,
    sx = _ref3$sx === void 0 ? {} : _ref3$sx,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _ref4 = "icon" in props ? props : _objectSpread({
      icon: undefined
    }, props),
    icon = _ref4.icon,
    propsMinusIcon = _objectWithoutProperties(_ref4, _excluded2);
  var _ref5 = "iconVariant" in propsMinusIcon ? propsMinusIcon : _objectSpread({
      iconVariant: undefined
    }, propsMinusIcon),
    iconVariant = _ref5.iconVariant,
    propsMinusIconAndIconVariant = _objectWithoutProperties(_ref5, _excluded3);
  var theme = useTheme();
  var currentIcon = useMemo(function () {
    switch (state) {
      case "loading":
        return {
          icon: "Loading",
          variant: "regular"
        };
      case "success":
        return {
          icon: "Tick",
          variant: "bold"
        };
      case "fatal":
        return {
          icon: "Exclamation",
          variant: "bold"
        };
      case "initial":
      default:
        return {
          icon: icon,
          variant: iconVariant
        };
    }
  }, [state, icon, iconVariant]);
  var buttConSx = merge({
    transitionProperty: "background, box-shadow",
    transitionDuration: function transitionDuration(_ref6) {
      var base = _ref6.base;
      return "".concat(base.motion.normal.gentle.cssDuration, ", ").concat(base.motion.normal.fast.cssDuration);
    },
    transitionTimingFunction: function transitionTimingFunction(_ref7) {
      var base = _ref7.base;
      return "".concat(base.motion.normal.gentle.cssEase, ", ").concat(base.motion.normal.fast.cssEase);
    }
  }, getButtConSx({
    state: state
  }), sx);
  var iconSx = getIconSx({
    state: state,
    theme: theme
  });
  return jsx(ButtCon, _objectSpread(_objectSpread({}, propsMinusIconAndIconVariant), {}, {
    variant: "tertiary",
    sx: buttConSx,
    iconSx: iconSx,
    icon: currentIcon.icon,
    iconVariant: currentIcon.variant
  }));
}
StatefulButtCon.displayName = "StatefulButtCon";
StatefulButtCon.SvgIcon = ButtConSvgIcon;

export { StatefulButtCon as S };
//# sourceMappingURL=StatefulButtCon.js.map
